import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { fmtApiError } from "@/lib/adminApi";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
    const [form, setForm] = useState({ email: "", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const { data } = await api.post("/auth/login", form);
            window.localStorage.setItem("hg_admin_token", data.access_token);
            toast.success("Welcome back!");
            navigate("/admin/dashboard");
        } catch (err) {
            setError(fmtApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="grid min-h-screen place-items-center bg-sand px-6" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <div className="rounded-3xl border border-border bg-white p-10 card-shadow">
                    <div className="flex justify-center"><Logo /></div>
                    <h1 className="mt-8 text-center font-serif text-2xl font-semibold text-ink">Admin Sign In</h1>
                    <p className="mt-2 text-center text-sm text-muted-foreground">Hindi Ganga team access only</p>
                    <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
                        <div className="space-y-2">
                            <Label htmlFor="admin-email">Email</Label>
                            <Input id="admin-email" type="email" required data-testid="admin-email-input"
                                value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                                className="bg-white" placeholder="you@hindiganga.com" />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="admin-password">Password</Label>
                            <Input id="admin-password" type="password" required data-testid="admin-password-input"
                                value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                                className="bg-white" placeholder="••••••••" />
                        </div>
                        {error && (
                            <p className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="admin-login-error">{error}</p>
                        )}
                        <button type="submit" disabled={loading} data-testid="admin-login-submit"
                            className="w-full rounded-full bg-saffron px-6 py-3.5 text-sm font-medium text-cream transition-all duration-300 hover:bg-teal disabled:opacity-60">
                            {loading ? "Signing in…" : "Sign In"}
                        </button>
                    </form>
                </div>
                <p className="mt-6 text-center text-xs text-muted-foreground">
                    <a href="/" className="underline hover:text-saffron" data-testid="back-to-site-link">← Back to the public website</a>
                </p>
            </div>
        </main>
    );
}
